(() => {
  const money = (amount, currency) => {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency', currency, minimumFractionDigits: 0, maximumFractionDigits: 2
      }).format(amount / 100);
    } catch { return (amount / 100).toFixed(2); }
  };
  const initProducts = scope => {
    scope.querySelectorAll('[data-product-root]').forEach(root => {
      if (root.dataset.bnhLayoutReady) return;
      root.dataset.bnhLayoutReady = 'true';
      const form = root.querySelector('[data-primary-atc]');
      const sticky = root.nextElementSibling?.matches('[data-sticky-atc]') ? root.nextElementSibling : null;
      if (!form || !sticky) return;
      let variants;
      try { variants = JSON.parse(root.querySelector('[data-variants]')?.textContent || '[]'); } catch { return; }
      const groups = [...root.querySelectorAll('[data-option-group]')];
      const image = sticky.querySelector('.bnh-sticky__image');
      const defaultImage = sticky.dataset.defaultImage || image?.src || '';
      const primaryWhatsApp = form.querySelector('[data-bnh-product-whatsapp]');
      const stickyWhatsApp = sticky.querySelector('[data-bnh-sticky-whatsapp]');
      const primaryButton = form.querySelector('button[type="submit"]');
      const stickyButton = sticky.querySelector('[data-sticky-button]');
      let currentVariantId;
      const sync = () => {
        const selections = groups.map(group => group.querySelector('input:checked, select')?.value);
        const variant = groups.length
          ? variants.find(item => item.options.every((option, index) => option === selections[index]))
          : variants.find(item => String(item.id) === form.querySelector('[name="id"]')?.value);
        const variantChanged = currentVariantId !== variant?.id;
        currentVariantId = variant?.id;
        const quantity = Math.max(1, parseInt(form.querySelector('[name="quantity"]')?.value || '1', 10) || 1);
        const quantityText = sticky.querySelector('[data-sticky-quantity]');
        if (quantityText) quantityText.textContent = `${quantityText.dataset.label}: ${quantity}`;
        const disabled = !variant?.available;
        root.querySelectorAll('[data-product-form] [name="id"]').forEach(input => { input.value = variant?.id || ''; });
        [primaryButton, stickyButton].forEach(button => {
          if (!button) return;
          button.disabled = disabled || form.getAttribute('aria-busy') === 'true';
          const label = button.querySelector('span') || button;
          label.textContent = !variant ? root.dataset.unavailable : variant.available ? button.dataset.available : button.dataset.sold;
        });
        const formattedPrice = variant ? money(variant.price, root.dataset.currency || 'PKR') : '';
        if (variantChanged) {
          root.querySelectorAll('[data-price]').forEach(price => { price.textContent = formattedPrice; });
          root.querySelectorAll('.price').forEach(price => {
            const comparison = price.querySelector('s');
            const badge = price.querySelector('.sale-badge');
            const onSale = variant && variant.compare_at_price > variant.price;
            if (comparison) { comparison.hidden = !onSale; if (onSale) comparison.textContent = money(variant.compare_at_price, root.dataset.currency || 'PKR'); }
            if (badge) { badge.hidden = !onSale; if (onSale) badge.textContent = `-${Math.round((variant.compare_at_price - variant.price) / variant.compare_at_price * 100)}%`; }
          });
        }
        const stickyPrice = sticky.querySelector('[data-sticky-price]');
        if (stickyPrice) stickyPrice.textContent = formattedPrice;
        if (image) {
          const source = variant?.featured_image?.src || defaultImage;
          if (source && image.getAttribute('src') !== source) { image.removeAttribute('srcset'); image.src = source; }
        }
        if (primaryWhatsApp) {
          const url = new URL(primaryWhatsApp.dataset.url, location.origin);
          if (variant) url.searchParams.set('variant', variant.id);
          const options = groups.map((group, index) => {
            const label = group.querySelector('legend')?.childNodes[0]?.textContent?.trim() || '';
            return selections[index] ? `${label}: ${selections[index]}` : '';
          }).filter(Boolean);
          const message = [primaryWhatsApp.dataset.greeting, primaryWhatsApp.dataset.title, ...options, `${primaryWhatsApp.dataset.quantityLabel}: ${quantity}`, url.href].join('\n');
          const href = `https://wa.me/${primaryWhatsApp.dataset.number.replace(/\D/g, '')}?text=${encodeURIComponent(message)}`;
          [primaryWhatsApp, stickyWhatsApp].filter(Boolean).forEach(link => {
            link.href = href;
            if (!variant) { link.setAttribute('aria-disabled', 'true'); link.setAttribute('tabindex', '-1'); }
            else { link.removeAttribute('aria-disabled'); link.removeAttribute('tabindex'); }
          });
        }
        if (variantChanged && variant) {
          const mediaId = variant.featured_media?.id || variant.featured_image?.id;
          const thumbnail = mediaId && root.querySelector(`[data-gallery-thumb][data-media-id="${mediaId}"]`);
          if (thumbnail && !thumbnail.classList.contains('is-active')) thumbnail.click();
          root.dispatchEvent(new CustomEvent('binahad:variant-change', { bubbles: true, detail: { variant, quantity } }));
        }
      };
      root.addEventListener('change', sync);
      root.addEventListener('input', event => { if (event.target.matches('[name="quantity"]')) sync(); });
      [primaryWhatsApp, stickyWhatsApp].filter(Boolean).forEach(link => {
        link.addEventListener('click', event => { sync(); if (link.getAttribute('aria-disabled') === 'true') event.preventDefault(); });
        link.addEventListener('contextmenu', sync);
      });
      const mainImage = root.querySelector('.pdp-main-image');
      const updateImageRatio = () => {
        if (mainImage?.naturalWidth && mainImage.naturalHeight) mainImage.closest('.pdp-main-media')?.style.setProperty('--bnh-media-ratio', mainImage.naturalWidth / mainImage.naturalHeight);
      };
      mainImage?.addEventListener('load', updateImageRatio);
      updateImageRatio();
      sync();
    });
  };
  const initRails = scope => {
    scope.querySelectorAll('[data-bnh-rail]').forEach(rail => {
      if (rail.dataset.bnhRailReady) return;
      rail.dataset.bnhRailReady = 'true';
      const track = rail.querySelector('[data-bnh-rail-track]');
      const previous = rail.querySelector('[data-bnh-rail-direction="previous"]');
      const next = rail.querySelector('[data-bnh-rail-direction="next"]');
      if (!track) return;
      const update = () => {
        const remaining = track.scrollWidth - track.clientWidth;
        if (previous) previous.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft >= remaining - 2;
        rail.querySelector('.collection-rail__actions')?.toggleAttribute('hidden', remaining < 3);
      };
      const scroll = direction => {
        const card = track.firstElementChild;
        const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        const distance = card ? card.getBoundingClientRect().width + gap : track.clientWidth;
        track.scrollBy({ left: direction * distance, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      };
      previous?.addEventListener('click', () => scroll(-1));
      next?.addEventListener('click', () => scroll(1));
      track.addEventListener('scroll', update, { passive: true });
      track.addEventListener('keydown', event => {
        if (event.target !== track || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        scroll(event.key === 'ArrowRight' ? 1 : -1);
      });
      if ('ResizeObserver' in window) new ResizeObserver(update).observe(track);
      update();
    });
  };
  const init = scope => { initProducts(scope); initRails(scope); };
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
